// extracted by mini-css-extract-plugin
export default {"wrapper":"FilesList_wrapper__6I4+J"};